/**
 * MiniTile — de små glassflisene i tre kolonner på Hjem (#154): Saldo, Ukas
 * leder og Middag.
 *
 * Hele flisen er en lenke til skjermen bak tallet. Flaten er glasskortet
 * (`GLASS_SURFACE` + kortskyggen, som Card), men som `<Link>` i stedet for en
 * knapp med `navigate`, så den kan åpnes i ny fane og leses som lenke.
 *
 * Etiketten er liten og dempet over verdien, slik skissen viser.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { GLASS_SURFACE } from '../../../components/primitives/Card';

interface MiniTileProps {
  to: string;
  label: ReactNode;
  children: ReactNode;
  /** Verdien er større for tall (Saldo) enn for navn og retter. */
  size?: 'number' | 'text';
  'data-testid': string;
  labelTestId?: string;
  valueTestId?: string;
}

export function MiniTile({
  to,
  label,
  children,
  size = 'text',
  'data-testid': testId,
  labelTestId,
  valueTestId,
}: MiniTileProps): ReactNode {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`${GLASS_SURFACE} flex min-h-11 min-w-0 flex-col gap-1.5 rounded-lg p-3.5 text-ink shadow-md`}
    >
      <span data-testid={labelTestId} className="text-caption font-semibold text-ink-2">
        {label}
      </span>
      <span
        data-testid={valueTestId}
        className={[
          'min-w-0 font-extrabold leading-tight break-words',
          size === 'number' ? 'text-heading-m tnum tracking-tight' : 'text-base',
        ].join(' ')}
      >
        {children}
      </span>
    </Link>
  );
}
